























































import { Component, Prop, Vue } from 'vue-property-decorator';
import PagesCoreAppBar from './components/core/AppBar.vue';
import PagesCoreView from './components/core/View.vue';
import PagesCoreFooter from './components/core/Footer.vue';

@Component({
  components: {
    PagesCoreAppBar,
    PagesCoreView,
    PagesCoreFooter,
  },
})
export default class PagesIndex extends Vue {
}
